import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import './Companies.css';

const Companies = () => {
  const [searchTerm, setSearchTerm] = useState('');

  // GET /companies (Node) o /companies/selector (PHP y Node)
  const { data, isLoading, error } = useQuery({
    queryKey: ['companies', searchTerm],
    queryFn: async () => {
      try {
        const params = searchTerm ? `?search=${encodeURIComponent(searchTerm)}` : '';
        const response = await api.get(`/companies${params}`);
        if (response.data.success && response.data.data?.companies) {
          return response.data.data.companies;
        }
      } catch {
        // PHP solo tiene /companies/selector
      }
      const sel = await api.get('/companies/selector');
      return (sel.data.success && sel.data.data) ? sel.data.data : [];
    }
  });

  const companies = Array.isArray(data) ? data : (data?.companies || data || []);

  if (isLoading) return <div className="companies-loading">Cargando empresas...</div>;
  if (error) return <div className="companies-error">Error al cargar empresas</div>;

  return (
    <div className="companies-page">
      <div className="page-header">
        <h2>Empresas</h2>
        <p className="page-subtitle">Gestiona las empresas del sistema (solo super_admin)</p>
      </div>

      <div className="filters-section">
        <input
          type="text"
          placeholder="Buscar por nombre o NIT..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="companies-list">
        <table className="companies-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>NIT</th>
              <th>Origen</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {companies.length === 0 ? (
              <tr>
                <td colSpan={5} className="empty-state">
                  No hay empresas registradas
                </td>
              </tr>
            ) : (
              companies
                .filter((c) => {
                  if (!searchTerm) return true;
                  const term = searchTerm.toLowerCase();
                  return (
                    (c.name || '').toLowerCase().includes(term) ||
                    (c.nit || '').toString().includes(term)
                  );
                })
                .map((company) => (
                  <tr key={company.id}>
                    <td>
                      <strong>{company.name || '—'}</strong>
                    </td>
                    <td>{company.nit || '—'}</td>
                    <td>
                      <span className={`source-badge source-${company.source || 'manual'}`}>
                        {company.source || 'manual'}
                      </span>
                    </td>
                    <td>
                      <span className={`status-badge ${company.is_active === false ? 'inactive' : 'active'}`}>
                        {company.is_active === false ? 'Inactiva' : 'Activa'}
                      </span>
                    </td>
                    <td>
                      <Link
                        to="/admin/dashboard"
                        className="btn-link"
                        onClick={() => {
                          localStorage.setItem('numbers_selected_company_id', company.id);
                          window.location.reload();
                        }}
                      >
                        Seleccionar
                      </Link>
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Companies;
